var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":""}},[_c('img',{staticClass:"pos",style:({
      bottom: _vm.size.bottom,
      right: _vm.size.right,
      width: _vm.size.width,
      height: _vm.size.height,
    }),attrs:{"src":_vm.imgLocation(_vm.list.image)},on:{"click":function($event){return _vm.toHref(_vm.list.link)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }